<template>
  <div class="group -full -flex -vs-small -center">
    <i class="icon -loading" aria-hidden="true" /><span class="sr-only">Loading</span>
  </div>
</template>

<script setup lang="ts"></script>
